import axios from 'axios';

const associateLanguage = languageId => axios.post(`languages/${languageId}`);

const removeLanguage = languageId => axios.delete(`languages/${languageId}`);

export { associateLanguage, removeLanguage };
